import to_array from 'to_array';

const Lang = require('lang');

function ValidarReciboPercurso(form) {
  if (form.getAttribute('id') !== 'form-percurso') {
    return true;
  }
  const $buttonFormSubmit = $(form).find('#submitPercurso');
  if ($(form).valid()) {
    // Se não valida o recibo, somente da submit validado
    if (!$buttonFormSubmit.hasClass('validating-receipt')) {
      return true;
    }
    if (!hasReceipt($(form))) {
      showNeedsReceiptDialog($(form));
      return false;
    }
    return true;
  }
}

function hasReceipt($form) {
  const inputs = $form.find('label.percurso-file-picker__add input[type="file"]');

  const inputsHasReceipts = inputs
    .toArray()
    .reduce((hasReceipt, input) => hasReceipt || (!!input && !!input.files.length), false)

  // Para os casos de editar percursos que contenham imagens
  const editHasFile = document.body.contains($form[0].querySelector('.has-file'));
  const methodForm = (document.body.contains($form[0].querySelector('[name="_method"]')))
    ? ($form[0].querySelector('[name="_method"]').value === 'PUT')
    : false;

  return inputsHasReceipts || (editHasFile && methodForm);
};

function showNeedsReceiptDialog($form) {
  bootbox.alert({
    title: Lang.get('js/src/functions/ExpenseLimit.no_receipt'),
    message: Lang.get('js/src/functions/ExpenseLimit.show_needs_receipt_message_in_track'),
    closeButton: false,
  }).on('hidden.bs.modal', evt => {
    $form.find('.file-picker').first().addClass('file-picker--error');
    $form.data('canSend', false);
  });

  $form.overlay('hide');
};

module.exports = ValidarReciboPercurso;
